export default __webpack_public_path__ + "static/media/share-icon.bc6dd8d3.svg";